import type { CopilotProposalSummary } from "@repo/app-types/entities/copilotProposal";
import { appPaths } from "../../../app/appPaths.js";
import { buildCopilotProposalLocation } from "../../researchAgent/copilotDeepLinks.js";
import type { CopilotProposalCardContent } from "../../researchAgent/copilotProposalCard.js";

/** What a knowledge base document proposal's card in the chat shows and opens. */
export function readKnowledgeBaseProposalCardContent(
  proposal: CopilotProposalSummary<"knowledgeBaseAttachment">,
): CopilotProposalCardContent {
  const documentLocation = appPaths.settingsKnowledgeBaseAttachment.build({
    knowledgeBaseId: proposal.data.knowledge_base_id,
    attachmentId: proposal.resource.id,
  });

  return {
    resourceType: "knowledgeBaseDocument",
    operation: "update",
    name: proposal.data.document_title,
    summary: proposal.data.summary,
    // The rewrite is reviewed as a diff in the editor, which is the only place
    // it reads as anything; the card says what changed and opens it.
    highlights: [],
    review: {
      kind: "open_editor",
      location: buildCopilotProposalLocation(documentLocation, proposal.id),
    },
    resourceLocation: { pathname: documentLocation },
  };
}
